import { render } from "./NewTicket.vue?vue&type=template&id=3bcc1666&scoped=true"
import script from "./NewTicket.vue?vue&type=script&lang=js"
export * from "./NewTicket.vue?vue&type=script&lang=js"

import "./NewTicket.vue?vue&type=style&index=0&id=3bcc1666&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcc1666"]])

export default __exports__